// 滚动条在Y轴上的滚动距离
export const getScrollTop = () => {
    let scrollTop = 0;
    let bodyScrollTop = 0;
    let documentScrollTop = 0;

    if (document.body) {
        bodyScrollTop = document.body.scrollTop;
    }

    if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
    }

    scrollTop = bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
    return scrollTop;
};

// 文档的总高度
export const getWindowHeight = () => {
    let windowHeight = 0;

    if (document.compatMode === 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight;
    } else {
        windowHeight = document.body.clientHeight;
    }

    return windowHeight;
};

// 浏览器视口的高度
export const getScrollHeight = () => {
    let scrollHeight = 0;
    let bodyScrollHeight = 0;
    let documentScrollHeight = 0;

    if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
    }

    if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
    }

    scrollHeight = bodyScrollHeight - documentScrollHeight > 0 ? bodyScrollHeight : documentScrollHeight;
    return scrollHeight;
};

export function getViewport(isHorizontal: boolean = false): {top: number, bottom: number} {
    const viewSize = {
        top: 0,
        bottom: 0,
    };
    const bottomBarEl = document.getElementById('topic-bottomBar');
    let bottomBarHeight = 0;
    if (bottomBarEl) {
        bottomBarHeight = 60;
    }

    viewSize.top = 0;
    // 服务按钮高度容错
    viewSize.bottom = window[isHorizontal ? 'innerWidth' : 'innerHeight'] - bottomBarHeight;


    return viewSize;
}

/**
 * detect elem wheather in viewport
 *
 * @param {DOM} elem, element to be detect
 * @param {Object} viewport, size of viewport
 * @param {number} threshold, detect threshold
 * @param {boolean} isHorizontal, detect direction: vertical/horizontal
 * @return {boolean} is in viewport
 */
// eslint-disable-next-line complexity
export function isInViewport(
    elem: HTMLElement, viewport: {top: number, bottom: number}, threshold: number, isHorizontal: boolean = false
) {
    const {top, bottom} = viewport;

    const offset = elem.getBoundingClientRect();
    const elemTop = offset[isHorizontal ? 'left' : 'top'] - threshold;
    const elemBottom = elemTop + offset[isHorizontal ? 'width' : 'height'] + 2 * threshold;
    // eslint-disable-next-line max-len
    if (elem.id && (elem.id === 'topic-bottomLeftBar' || elem.id === 'topic-bottomRightBar' || elem.id === 'topic-bottomMiddleBar')) {
        return true;
    }

    return (elemTop > top && elemTop < bottom)
        || (elemBottom >= top && elemBottom <= bottom)
        || (elemTop <= top && elemBottom >= bottom);
}

export function pageHide(fn: () => void): void {

    if (!document) {
        return;
    }

    const pageHideEvent = [
        'pagehide',
        'visibilitychange',
        'mozvisibilitychange',
        'msvisibilitychange',
        'webkitvisibilitychange',
    ];
    let hidden: string = '';
    let complate = false;

    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
    } else if (typeof (document as any).msHidden !== 'undefined') {
        hidden = 'msHidden';
    } else if (typeof (document as any).mozHidden !== 'undefined') {
        hidden = 'mozHidden';
    } else if (typeof (document as any).webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
    }
    pageHideEvent.forEach(eventName => {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        document.removeEventListener(eventName, cb);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        document.addEventListener(eventName, cb);

        function cb(e: Event) {
            if (!complate && ((document as any)[hidden] || (e as any).hidden)) {
                complate = true;
                fn();
                // 下一事件循环清除状态值
                setTimeout(() => {
                    complate = false;
                }, 0);
            }
        }
    });
}
export function pageShow(fn: () => void): void {
    if (!document) {
        return;
    }

    let hidden: string = '';
    let visibilityChange = '';
    let complete = false;
    let hiddenCb: any = null;

    if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
    } else if (typeof (document as any).msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
    } else if (typeof (document as any).mozHidden !== 'undefined') {
        hidden = 'mozHidden';
        visibilityChange = 'mozvisibilitychange';
    } else if (typeof (document as any).webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
    }
    function cb() {

        if (!complete && hiddenCb && hiddenCb()) {
            complete = true;
            fn();
            // 下一事件循环清除状态值
            setTimeout(() => {
                complete = false;
            }, 100);
            return;
        }

        if (!complete && !(document as any)[hidden]) {
            complete = true;
            fn();
            // 下一事件循环清除状态值
            setTimeout(() => {
                complete = false;
            }, 100);
        }
    }

    const events = [visibilityChange, 'pageshow', 'readystatechange', 'popstate'];
    events.forEach(
        eventName => {
            if (eventName === 'readystatechange') {
                hiddenCb = () => document.readyState === 'complete';
            }

            if (eventName === 'popstate') {
                hiddenCb = () => true;
            }

            window.removeEventListener(visibilityChange, cb);
            window.addEventListener(visibilityChange, cb);
        }
    );
}
